/* eslint-disable no-restricted-imports */
import { ZodNumber, ZodString, ZodStringFormat, ZodUnion } from 'zod'

const getNumberMin = (value: ZodNumber | ZodUnion<[ZodNumber, ...ZodNumber[]]>): number | undefined => {
    const checks = value instanceof ZodUnion ? value?.def?.options?.[0]?.def?.checks : value?.def?.checks
    const check = checks?.find((check) => check._zod.def.check === 'greater_than')
    if (check) {
        if ('value' in check._zod.def) {
            return check._zod.def.value as number
        }
    }
}

const getNumberMax = (value: ZodNumber | ZodUnion<[ZodNumber, ...ZodNumber[]]>): number | undefined => {
    const checks = value instanceof ZodUnion ? value?.def?.options?.[0]?.def?.checks : value?.def?.checks

    const check = checks?.find((check) => check._zod.def.check === 'less_than')
    if (check) {
        if ('value' in check._zod.def) {
            return check._zod.def.value as number
        }
    }
}

export const getMinMax = (value: ZodNumber | ZodUnion<[ZodNumber, ...ZodNumber[]]>): { min?: number; max?: number } => {
    return {
        min: getNumberMin(value),
        max: getNumberMax(value),
    }
}

export const getMinMaxLength = (value: ZodString | ZodStringFormat, returnSize: boolean = false) => {
    const result: { minLength?: number; maxLength?: number; size?: number } = {}

    const minLength = value?.minLength
    const maxLength = value?.maxLength

    const size = returnSize ? maxLength : undefined

    if (typeof minLength === 'number') {
        result.minLength = minLength
    }

    if (typeof maxLength === 'number') {
        result.maxLength = maxLength
    }

    if (typeof size === 'number') {
        result.size = size
    }

    return result
}
